import { Tabs } from 'antd';

import { DefaultLayout } from '@/layouts/DefaultLayout';



const ServiceTable = () => {

  return (
    <DefaultLayout>
      <div style={{ width: '100%' }}>
        <div className="service-tabs-wrapper">
          <Tabs
            defaultActiveKey="visao-geral"
            className="automation-tabs"
            style={{ width: '100%' }}
          />
        </div>

      </div>
    </DefaultLayout>
  );
};

export default ServiceTable;
